module.exports = __webpack_public_path__ + "img/loaderrimg.306b8e93.png";